import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { deleteGramaticaDebil, deleteGramaticaFuerte } from './../../routing/routes';

const Gramaticas = ({ gramaticas, permisos, setNotification, refreshData }) => {
	const [mode, setMode] = useState(true);
	return (
		<div>
			<div className='tabMenu' style={{ marginTop: 20, marginBottom: 15 }}>
				<div onClick={() => setMode(true)} style={{ paddingTop: 5, paddingBottom: 5 }} className={mode ? 'tabChild tabChild-selected' : 'tabChild'}>
					Fuertes
				</div>
				<div onClick={() => setMode(false)} style={{ paddingTop: 5, paddingBottom: 5 }} className={!mode ? 'tabChild tabChild-selected' : 'tabChild'}>
					Débiles
				</div>
			</div>
			<h1 style={{ textAlign: 'center', marginTop: 0 }}>Gramáticas {mode ? 'Fuertes' : 'Débiles'}</h1>
			{mode ? (
				<GramaticasFuertesTable gramaticas={gramaticas.fuertes} permisos={permisos} setNotification={setNotification} refreshData={refreshData} />
			) : (
				<GramaticasDebilesTable gramaticas={gramaticas.debiles} permisos={permisos} setNotification={setNotification} refreshData={refreshData} />
			)}
		</div>
	);
};

const GramaticasDebilesTable = ({ gramaticas, permisos, setNotification, refreshData }) => {
	const history = useHistory();
	return (
		<div style={{ position: 'relative' }}>
			{permisos.crearGramaticasDebiles && (
				<Link to='/gramaticas/new/debil'>
					<button className='floatingButton'>+</button>
				</Link>
			)}
			{gramaticas.map((grama) => {
				return (
					<div style={{ position: 'relative' }} key={grama.nombre}>
						<div className={'intent'} onClick={() => permisos.modificarGramaticasDebiles && history.push('/gramaticas/edit/debil/' + grama._id)}>
							<h2 style={{ margin: 0, marginLeft: 30 }}>{grama.nombre}</h2>
						</div>
						{permisos.eliminarGramaticasDebiles && (
							<button
								onClick={() => {
									deleteGramaticaDebil(grama._id)
										.then(() => {
											refreshData();
											setNotification('mGramática débil borrada correctamente');
										})
										.catch(() => {
											setNotification('eNo se ha podido borrar la gramática débil');
										});
								}}
								className='floatingButtonDelete'
							>
								X
							</button>
						)}
					</div>
				);
			})}
		</div>
	);
};

const GramaticasFuertesTable = ({ gramaticas, permisos, setNotification, refreshData }) => {
	const history = useHistory();
	return (
		<div style={{ position: 'relative' }}>
			{permisos.crearGramaticasFuertes && (
				<Link to='/gramaticas/new/fuerte'>
					<button className='floatingButton'>+</button>
				</Link>
			)}
			{gramaticas.map((grama) => {
				return (
					<div style={{ position: 'relative' }} key={grama.nombre}>
						<div className={'intent'} onClick={() => permisos.modificarGramaticasFuertes && history.push('/gramaticas/edit/fuerte/' + grama._id)}>
							<h2 style={{ margin: 0, marginLeft: 30 }}>{grama.nombre}</h2>
						</div>
						{permisos.eliminarGramaticaFuertes && (
							<button
								onClick={() => {
									deleteGramaticaFuerte(grama._id)
										.then(() => {
											refreshData();
											setNotification('mGramática fuerte borrada correctamente');
										})
										.catch(() => {
											setNotification('eNo se ha podido borrar la gramática fuerte');
										});
								}}
								className='floatingButtonDelete'
							>
								X
							</button>
						)}
					</div>
				);
			})}
		</div>
	);
};

export default Gramaticas;
